"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var standardViewports = exports.standardViewports = {
    xsmall: 0,
    small: 601,
    medium: 961,
    large: 1281,
    xlarge: 1681
};
exports.default = standardViewports;
//# sourceMappingURL=viewports.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/ViewportManager/viewports.js